import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { Buffer } from 'buffer';

const ImageViewer = ({ image, imageViewer, setImageViewer }) => {

    const handleClose = () => {
        setImageViewer({ show: false });
    }

    return (
        <Dialog fullScreen open={imageViewer.show} onClose={handleClose}>
            <DialogContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3 }}>
                <Box
                    component="img"
                    sx={{ maxHeight: '75vh', maxWidth: '100%' }}
                    src={`data:image/png;base64,${Buffer.from(imageViewer.image).toString('base64')}`}
                />
            </DialogContent>
            <DialogActions sx={{ bgcolor: 'common.black' }}>
                <Button variant="outlined" onClick={handleClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
};

export default ImageViewer;
